













































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { required, email } from 'vuelidate/lib/validators';

import BaseInput from '@/components/ui/form/BaseInput.vue';
import BaseTextarea from '@/components/ui/form/BaseTextarea.vue';
import BaseButton from '@/components/ui/buttons/Button.vue';

import IContactFormData from '@/store/modules/contact/types/IContactFormData';

@Component({
  validations: {
    names: {
      required,
    },
    email: {
      required,
      email,
    },
    subject: {
      required,
    },
    message: {
      required,
    },
  },
  components: {
    BaseInput,
    BaseTextarea,
    BaseButton,
  },
})
export default class ContactForm extends Vue {
  private names: string = '';
  private email: string = '';
  private subject: string = '';
  private message: string = '';

  private mounted(): void {
    this.$bus.$on('clear-contact-form', this.clearForm);
  }

  private destroyed(): void {
    this.$bus.$off('clear-contact-form', this.clearForm);
  }

  private validate(): void {
    if (this.$v) {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.submit();
      }
    }
  }

  private submit(): void {
    const formData: IContactFormData = {
      names: this.names,
      email: this.email,
      subject: this.subject,
      message: this.message,
    };

    this.$store.dispatch('contact/submit', formData);
  }

  private clearForm(): void {
    this.names = '';
    this.email = '';
    this.subject = '';
    this.message = '';

    if (this.$v) {
      this.$v.$reset();
    }
  }
}
